import { withStylePrefix } from '../../common/withStylePrefix';
import { PopoverContentComponent, popoverContentTemplate } from './PopoverContent';
import styles from './PopoverContent.styles.scss';
export const popoverContentDefinition = {
    baseName: 'popover-content',
    template: popoverContentTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonPopoverContent = PopoverContentComponent.compose(popoverContentDefinition);
